import { buildAccentGroups, buildNeutrals } from "./buildPalette";
import {
  roleColors_dark,
  roleColors_light,
  semanticColors_dark,
  semanticColors_light,
  statusColors_dark,
  statusColors_light,
} from "./semantics";
import { APP_THEME_SPECS, type AppThemeId, type AppThemeSpec } from "./themeSpecs";

export const buildPalette = (spec: AppThemeSpec) => {
  const dark = spec.mode === "dark";
  const semantics = dark ? semanticColors_dark : semanticColors_light;
  const accentGroups = buildAccentGroups(spec);

  return {
    surface: buildNeutrals(spec),
    colors: {
      orange: accentGroups.orange,
      yellow: semantics.yellow,
      blue: semantics.blue,
      gray: accentGroups.gray,
      success: semantics.success,
      warning: semantics.warning,
      danger: semantics.danger,
      info: semantics.info,
      warmWhite: accentGroups.warmWhite,
      lightGray: accentGroups.lightGray,
      inverse: accentGroups.inverse,
      muiGrey: accentGroups.muiGrey,
      muiBlueGrey: accentGroups.muiBlueGrey,
    },
    roleColors: dark ? roleColors_dark : roleColors_light,
    statusColors: dark ? statusColors_dark : statusColors_light,
  };
};

export type PaletteShape = ReturnType<typeof buildPalette>;

export const palettes = APP_THEME_SPECS.reduce(
  (accumulator, spec) => {
    accumulator[spec.id] = buildPalette(spec);
    return accumulator;
  },
  {} as Record<AppThemeId, PaletteShape>,
);

export const lightPalette = palettes.flownect;
export const darkPalette = palettes.midnight;
